import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { ApproveButton } from '../../../mui/Buttons/Buttons'
import { savePaginationData } from '../../../../redux/features/globalDatagridSlice'

const ApproveGlobal = ({isDisabled,loading,upDateCall,statusChangeApiCall,buttonName}) => {
    const { enqueueSnackbar } = useSnackbar()
    const dispatch=useDispatch()
    const { paginationData } = useSelector((state) => state.globalDataGrid)
    const approveAction=()=>{

        dispatch(statusChangeApiCall).then((res) => {
            if (res.payload.status === 'error') {
              enqueueSnackbar(res.payload.message, {
                variant: 'error',
              })
            } else if (res.payload.status === 'success') {
              dispatch(savePaginationData({ ...paginationData, openAnchor: false }))
              dispatch(upDateCall)
              enqueueSnackbar(res.payload.message, {
                variant: 'success',
              })
            }
          })
    }
  return (
    <ApproveButton children={buttonName} disabled={isDisabled || loading} action={approveAction}/>
  )
}

export default ApproveGlobal